import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import reducer from '../reducers';
import analytics from '../analytics';

export const ignoreNullActionsMw = () =>
  next => (action) => {
    if (!action) {
      return null;
    }

    return next(action);
  };

const middlewarelist = [ ignoreNullActionsMw, promise(), thunk ];
const middleware =
  process.env.NODE_ENV !== 'production'
    ? composeWithDevTools(applyMiddleware(...middlewarelist, createLogger({ collapsed: true })))
    : applyMiddleware(...middlewarelist);

const store = createStore(reducer, middleware);

store.subscribe(() => {
  analytics.populateFromStore(store.getState());
});

export default store;
